import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-will-be-lost',
  templateUrl: './will-be-lost.component.html',
  styleUrls: ['./will-be-lost.component.scss'],
  standalone: true,
  imports: [CdsButtonModule, CdsLanguageModule],
})
export class WillBeLostComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<WillBeLostComponent>>(MatDialogRef);

  ngOnInit(): void {}

  onCancel() {
    this.dialogRef.close({ agree: false });
  }

  onContinue() {
    this.dialogRef.close({ agree: true });
  }
}
